import styled from 'styled-components'

export const Container = styled.div`
  max-width: 1423px;
  padding: 0 10px;
  width: 100%;
  margin: 0 auto;
  @media (max-width: 1250px) {
    padding:0 15px;
  }
  .MuiAppBar-colorPrimary {
    background-color: transparent;
    box-shadow: none;
    padding-bottom: 25px;
  }
  .MuiTab-textColorInherit.Mui-selected {
    color: #0a1f30;
    font-family: "latobold" !important;
  }
  .MuiTab-textColorInherit {
    color: #7a7a7a;
    opacity: 1;
    text-transform: capitalize;
    font-size: 16px;
    font-family: "latomedium" !important;
  }
  .MuiTabs-indicator {
    background-color: #2fb5f1;
    height: 4px;
  }
  .MuiBox-root {
    padding: 0;
  }
  .MuiTab-wrapper{
    flex-direction: row;
    gap: 8px;
    align-items: center;
  }
  .MuiIconButton-edgeEnd{
    margin-right: -12px !important;
  }
  .notification {
    color: #ffffff;
    background-color: #3fb144;
    padding: 2px;
    border-radius: 50%;
    height: 24px;
    min-width: 24px;
    top: 44px;
    right: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
  }
`;

export const SearchSection = styled.div`
  max-width: 650px;
  width: 55vw;
  border-radius: 3px;
  padding: 2px 15px;
  position: relative;
  margin-left: 10px;
  input{
    border-radius: 23px;
    box-shadow: 0 3px 6px 0 rgb(0 0 0 / 16%);
    border: solid 1px #fff;
    background-color: #fff;
    height: 40px;
    padding: 18px;
    width: 100%;
    &::placeholder {
      color: #b4b4b4;
    }
  }
  @media (max-width: 500px) {
    padding: 0px;
    margin-left: 0px;
  }
`;
export const OrderTopHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e1e1e1;
  > div {
    .custom-select__control {
      border-radius: 23px;
      box-shadow: 0 3px 6px 0 rgb(0 0 0 / 16%);
      border: solid 1px #fff;
      background-color: #fff;
      height: 40px;
    }
    :first-child {
      width: 225px;
    }
    :nth-child(2) {
      padding: 0;
    }
  }
  @media (max-width: 500px) {
    display: grid;
    gap: 15px;
  }
`;
export const SectionWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 46px;
  margin-top: 10px;

  @media (max-width: 1250px) {
    grid-template-columns: 1fr;
    .pd-right-nav {
      display: none;
    }
  }
  @media (max-width: 767px) {
    display: flex;
    flex-direction: column-reverse;
    gap: 0px;
  }
`;
export const Description = styled.div`
  position: relative;
  width: auto;
  overflow-x: visible;
  overflow-y: hidden;
  .order-count-class{
    color: #ffffff;
    background-color: #3fb144;
    padding: 2px;
    border-radius: 50%;
    height: 22px;
    min-width: 22px;
    top: 44px;
    right: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
  }
  img.right-arrow {
    position: absolute;
    left: -16px;
    top: 5px;
    height: 39px;
    width: 53px;
  }
  .pallete-image.borderLightBlue{
    border: 1px solid #87cdf1 !important;
  }
  .pallete-image.borderDarkBlue{
    border: 1px solid #0a5587 !important;
  }
  .MuiTabs-flexContainer{
    justify-content: space-between !important;
  }
  .MuiAppBar-colorPrimary{
    padding-bottom: 10px;
  }
`;
export const FilterWrapper = styled.div`
  margin-left: 10px;
  box-shadow: 0 3px 6px 0 rgb(0 0 0 / 16%);
  padding: 5px;
  border-radius: 10px;
  img {
    cursor: pointer;
  }
`;

export const TabContentWrapper = styled.div`
  .pending-tab-content-mobile-view{
    display: none;
    box-shadow: 1px 2px 1px -1px #00000033;
    border: 1px solid #e4e4e4;
    border-radius: 5px;
    padding: 15px 10px;
    h6{
      font-size: 15px;
      font-family: 'latobold';
    }
    hr{
      margin: 0px;
    }
    .outer-wrapper{
      padding: 0 15px;
    }
    .row-class{
      display: flex;
      justify-content: space-between;
    }
    .elements-class{
      min-width: 130px;
      margin-bottom: 5px;
      p{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 125px;
      }
    }
    .button-wrapper{
      display: flex;
      gap: 15px;
      margin-top: 15px;
      justify-content: end;
      margin-right: 10px;
      button{
        border: none;
        border-radius: 5px;
        padding: 0 15px;
        height: 36px;
        cursor: pointer;
        color: #fff;
        background: linear-gradient(180deg, #0A5587 0%, #12659D 100%);
      }
    }
  }
  .pending-tab-content-web-view{
    display: flex;
    gap: 10px;
    min-width: 800px;
    justify-content: space-between;
    padding: 0 12px;
    border-radius: 5px;
    box-shadow: 0px 1px 3px 0px rgb(0 0 0 / 33%);
    background: #FFFFFF;
    min-height: 50px;
    align-items: center;
    margin-top: 15px;
    p{
      flex: 1;
    }
    .button-wrapper{
      display: flex;
      gap: 15px;
      button{
        border: none;
        border-radius: 5px;
        padding: 0 15px;
        height: 36px;
        cursor: pointer;
        color: #fff;
        background: linear-gradient(180deg, #0A5587 0%, #12659D 100%);
      }
    }
  }
  .accordion-tab-content-web-view{
    display: block;
    margin-bottom: 10px;
  }
  .accordion-tab-content-mobile-view{
    display: none;
    margin-bottom: 10px;
  }
  .raise-raise-button-style{
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 10px;
    button{      
      background: linear-gradient(180deg, #0A5587 0%, #12659D 100%);
      color: #fff;
      width: 152px;
      font-size: 13px;
      border: none;
      border-radius: 5px;
      padding: 0 15px;
      height: 37px;
    }
    .timer-class{
      color: #D43900;
      font-size: 13px;
      font-family: 'latobold';
    }
  }
  .resche-button-wrapper{
    display: flex;
    gap: 20px;
  }  
  .res-button-style{
    background: linear-gradient(180deg, #0A5587 0%, #12659D 100%);
    color: #fff;
    width: 152px;
    font-size: 13px;
    border: none;
    border-radius: 5px;
    padding: 0 15px;
    height: 37px;
  } 
  .resche-button-wrapper-mobile{
    display: grid;
    gap: 20px;
    .res-button-style{
      width: 100%;
    }  
  } 
  .assigned-header-style{
    display: flex;
    gap: 15px;
  }
  .assigned-header-style-header{
    flex-direction: column;
    align-items: end;
  }
  .claim-buttons-style{
    display: flex;
    gap: 15px;
    button{
      border: none;
      border-radius: 5px;
      padding: 0 15px;
      height: 36px;
      cursor: pointer;
      background: linear-gradient(180deg, #0A5587 0%, #12659D 100%);
      color: #fff;
      width: 152px;
      font-size: 13px;
    }
  }
  .claim-buttons-style-header{
    flex-direction: column;
    align-items: end;
  }
  .claim-buttons-style-mobile{
    flex-direction: column;
    button{
      width: 100%;
    }
  }
  @media (max-width: 500px) {
    .pending-tab-content-web-view{
      display: none;
    }
    .accordion-tab-content-web-view{
      display: none;
    }
    .pending-tab-content-mobile-view{
      display: block;
    }
    .accordion-tab-content-mobile-view{
      display: block;
    }
  }
`
export const AccordionHeaderWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    width: 100%;
    gap: 20px;
    padding: 0 10px;
    .order-status-ASSIGNED{
      color: #68a107;
    }
    .order-status-RESCHEDULED{
      color: orange;
    }
    .order-status-CLAIM{
      color: red;
    }
    .order-status-PICKEDUP{
      color: #68a107;
    }
    .order-status-HOLD{
      color: orange;
    }
    .order-status-COMPLETE{
      color: black;
    }
    .order-status-CANCELLED{
      color: red;
    }
    .receipt-style{
        border: none;
        border-radius: 5px;
        padding: 0 15px;
        height: 36px;
        cursor: pointer;
        background: linear-gradient(180deg, #0A5587 0%, #12659D 100%);
        color: #fff;
        width: 152px;
        font-size: 13px;
    }
    @media (max-width: 1024px){
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    }
    @media (max-width: 767px){
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
    @media (max-width: 600px){
      grid-template-columns: 1fr 1fr 1fr;
    }
    p{
      text-overflow: ellipsis;
      overflow: hidden;
    }
`

export const AccordionHeaderWrapperMobile = styled.div`
    display: grid;
    width: 100%;
    padding: 0 10px;
    .elements-class{
      display: grid;
      grid-template-columns: 2fr 1fr;
    }
    .MuiIconButton-edgeEnd{
      margin: 0 !important;
    }
    .order-status-ASSIGNED{
      color: #68a107;
    }
    .order-status-RESCHEDULED{
      color: orange;
    }
    .order-status-CLAIM{
      color: red;
    }
    .order-status-PICKEDUP{
      color: #68a107;
    }
    .order-status-HOLD{
      color: orange;
    }
    .order-status-COMPLETE{
      color: black;
    }
    .order-status-CANCELLED{
      color: red;
    }
    .receipt-style{
        border: none;
        border-radius: 5px;
        padding: 0 15px;
        height: 36px;
        cursor: pointer;
        background: linear-gradient(180deg, #0A5587 0%, #12659D 100%);
        color: #fff;
        width: 152px;
        font-size: 13px;
    }

    p{
      text-overflow: ellipsis;
      overflow: hidden;
    }
`

export const AccordionDetailsWrapper = styled.div`
    padding: 0px 15px 15px 20px;
    width: 100%;
    .main-div{
      display: flex;
      margin-bottom: 15px;
      p{
        width: 300px;
        margin: 0;
        font-family: 'latobold';
      }
    }
    .main-div-mobile{
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 20px;
      margin-bottom: 15px;
      .ellipsis-class{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 174px;
      }
      p{
        margin: 0;
        font-family: 'latobold';
      }
    }
    .qty-style{
      position: relative;
      display: flex;
      align-items: center;
      img{
        height: 17px;
        width: 17px;
        position: absolute;
        right: 10px;
        cursor: pointer;
      }
      .save-image{
        height: 20px;
        width: 20px;
      }
      .app-input-text{
        margin: 0!important;
      }
    }
    .tracking-details{
      margin-top: 100px;
    }
    .pickup-orders-button-wrapper{
      display: flex;
      justify-content: space-between;
    }
    .pickup-orders-button-wrapper-mobile{
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    .rescheduled-order-action-style{
      display: flex;
      flex-direction: column;
      align-items: center;
      button{
        border: none;
        border-radius: 5px;
        padding: 0 15px;
        height: 36px;
        cursor: pointer;
        color: #fff;
        background: linear-gradient(180deg, #0A5587 0%, #12659D 100%);
      }
      p{
        color: blue;
      }
    }
    .retry-payment-class{
      button{
        border: none;
        border-radius: 5px;
        padding: 0 15px;
        height: 36px;
        cursor: pointer;
        color: #fff;
        background: #68A107;
        margin-bottom: 10px;
      }
    }
    .receipt-style{
        border: none;
        border-radius: 5px;
        padding: 0 15px;
        height: 36px;
        cursor: pointer;
        background: linear-gradient(180deg, #0A5587 0%, #12659D 100%);
        color: #fff;
        width: 152px;
        font-size: 13px;
        margin-right: 10px;
    }    
    .receipt-style-mobile{
      width: 100%;
      margin-right: 0px;
    }
`
